import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography, withStyles } from "@material-ui/core";
import CancelAcceptForm from "../../Common/CancelAcceptForm";
import t from "../../../languages/pl";
import { isEmail } from '../../../utils/helpers';
import DefaultAndIndividualEmails from '../../Common/DefaultAndIndividualEmails';


const useStyles = theme => ({
    content: {
        margin: theme.spacing(1)
    },
    badEmail: {
        fontSize: 12,
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        color: "red",
    },
    correctEmail: {
        fontSize: 12,
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
    }
});

const EmailsDialog = props => {
    const { classes, open, onClose, onSubmit, inputEmails } = props;
    const [value, setValue] = useState([]);
    const [lastEmail, setLastEmail] = useState("");
    const [isCorrectEmail, setIsCorrectEmail] = useState(false);

    useEffect(() => {
        if(inputEmails){
            setValue(inputEmails);
        }
    }, [inputEmails]);

    const handleEmailListChange = (emails) => {
        setValue(emails);
    };

    const handleTypedTextChange = (text) => {
        if(text === "" || isEmail(text)){
            setIsCorrectEmail(true);
        } else {
            setIsCorrectEmail(false);
        }

        setLastEmail(text);
    };

    const handleSubmit = () => onSubmit && onSubmit(value);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle>
                {t.emailsAddresses}
            </DialogTitle>
            <DialogContent className={classes.content}>
                <DefaultAndIndividualEmails
                    emails={value}
                    onEmailListChange={handleEmailListChange}
                    onTextChange={handleTypedTextChange}
                    setDefaultOnStart
                />
                {lastEmail === "" && value.length === 0
                    ?
                    null
                    : isCorrectEmail
                        ?
                        lastEmail === ""
                            ?
                            null
                            :
                            <Typography
                                variant="body1"
                                className={classes.correctEmail}
                            >
                                {t.correctAddressEmailInformation}
                            </Typography>
                        :
                        <Typography
                            variant="body1"
                            className={classes.badEmail}
                        >
                            {t.lastEmailIsIncorrect}
                        </Typography>
                }
            </DialogContent>
            <DialogActions>
                <CancelAcceptForm
                    onCancel={onClose}
                    onSubmit={handleSubmit}
                    disableSubmit={value.length === 0 || lastEmail.trim() !== ""} />
            </DialogActions>

        </Dialog>
    );
};

EmailsDialog.propTypes = {
    classes: PropTypes.object,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    inputEmails: PropTypes.array
};

EmailsDialog.defaultProps = {
    inputEmails: []
};

export default withStyles(useStyles)(EmailsDialog);
